module.exports = __webpack_public_path__ + "img/stackslash-62-mobile.085fbf5c.jpg";